var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 139,
    height: 139,
    viewBox: "0 0 139 139",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.5001 23.168C75.6443 23.168 81.5368 25.6087 85.8814 29.9533C90.226 34.2979 92.6667 40.1905 92.6667 46.3346C92.6667 52.4788 90.226 58.3713 85.8814 62.7159C81.5368 67.0605 75.6443 69.5013 69.5001 69.5013C63.3559 69.5013 57.4634 67.0605 53.1188 62.7159C48.7742 58.3713 46.3334 52.4788 46.3334 46.3346C46.3334 40.1905 48.7742 34.2979 53.1188 29.9533C57.4634 25.6087 63.3559 23.168 69.5001 23.168ZM69.5001 34.7513C66.428 34.7513 63.4817 35.9717 61.3094 38.144C59.1371 40.3163 57.9167 43.2625 57.9167 46.3346C57.9167 49.4067 59.1371 52.353 61.3094 54.5253C63.4817 56.6976 66.428 57.918 69.5001 57.918C72.5722 57.918 75.5184 56.6976 77.6907 54.5253C79.863 52.353 81.0834 49.4067 81.0834 46.3346C81.0834 43.2625 79.863 40.3163 77.6907 38.144C75.5184 35.9717 72.5722 34.7513 69.5001 34.7513ZM69.5001 75.293C84.9638 75.293 115.833 82.9959 115.833 98.4596V115.835H23.1667V98.4596C23.1667 82.9959 54.0363 75.293 69.5001 75.293ZM69.5001 86.2971C52.2988 86.2971 34.1709 94.753 34.1709 98.4596V104.83H104.829V98.4596C104.829 94.753 86.7013 86.2971 69.5001 86.2971Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/ProfileIcon.0e7941cfeb27f87f18358183dc9818d5.svg";
export { ForwardRef as ReactComponent };